'use client';

import type { Theme, SxProps } from '@mui/material/styles';

import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';

import { Iconify } from 'src/components/iconify';

/** 접근 이름이자 툴팁 — 테스트·시나리오는 이 이름으로 단추를 찾는다 */
export const FILTER_RESET_LABEL = '필터 초기화';

/**
 * **필터 초기화 단추 한 벌** — 칩 줄 끝·필터 카드 머리 어디서든 같은 원형 되돌리기 아이콘.
 * 크기는 조건 칩(`HubChip`)·고르개와 같은 28px 이라 칩 줄에 섞여 서도 줄이 울퉁불퉁하지 않다.
 * ⚠️ 무엇을 되돌리는지는 부르는 쪽의 `onClick` 이 정한다 — 이 부품은 겉모양만 쥔다.
 * ⚠️ `show` 가 거짓이면 **아무것도 그리지 않는다**(흐린 비활성이 아니라 숨김) — 늘 서 있으면 걸린 것이 있는지 알 수 없다.
 *   자리를 잡아 둬야 하는 화면은 부르는 쪽이 감싸는 상자로 잡는다.
 * @param count 걸린 조건 수 — 주면 툴팁에 「필터 초기화 (N)」으로 적는다(접근 이름은 늘 「필터 초기화」)
 */
export function FilterResetButton({
  onClick,
  show = true,
  count,
  sx,
}: {
  onClick: () => void;
  show?: boolean;
  count?: number;
  sx?: SxProps<Theme>;
}) {
  if (!show) return null;

  const title = count ? `${FILTER_RESET_LABEL} (${count})` : FILTER_RESET_LABEL;

  return (
    <Tooltip title={title}>
      <IconButton
        size="small"
        aria-label={FILTER_RESET_LABEL}
        onClick={onClick}
        sx={[{ width: 28, height: 28, flexShrink: 0, color: 'text.secondary' }, ...(Array.isArray(sx) ? sx : [sx])]}
      >
        <Iconify icon="solar:restart-linear" width={16} />
      </IconButton>
    </Tooltip>
  );
}
